import { useQuery } from '@tanstack/react-query';
import { listResource } from '@diggens/api-client';

export interface Thread {
  id: string;
  message_id: string;
  thread_id: string;
  subject: string;
  body_html?: string;
  sent_at: string;
  from_email: string;
  to_emails: string[];
  cc_emails?: string[];
  bcc_emails?: string[];
  source: string;
  source_id: string;
}

export function useThreads(activityNodeId: string) {
  return useQuery({
    queryKey: ['threads', activityNodeId],
    queryFn: async () => {
      const { data } = await listResource<Thread>('submission_thread', { node_id: activityNodeId });
      return data;
    },
    enabled: !!activityNodeId,
  });
}
